<template>
    <div class="container">
        <div class="row">
            <div class="col">
                <h3 class="page-title">Queues List</h3>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <table class="table table-hover table-sm">
                    <thead>
                        <tr>
                            <th class="column-rownumber">#</th>
                            <th class="column-actions">Details</th>
                            <th class="column-status">Status</th>
                            <th class="column-name">Name</th>
                            <th class="column-actions">Remove</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(queue, $index) in sortedByNameQueues">
                            <td>{{ $index + 1}}</td>
                            <td>
                                <button class="btn btn-primary btn-sm" @click="openDetails(queue)">
                                    Details
                                </button>
                            </td>
                            <td>{{ getQueueStates(queue) }}</td>
                            <td>{{ queue.name }}</td>
                            <td>
                                <button
                                    class="btn btn-danger btn-sm"
                                    v-if="$isAdmin() && queue.states.pending"
                                    @click="removePendingJobs(queue)"
                                >
                                    Remove pending
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <details-modal v-if="detailQueueName" :queue="detailQueueName" @modalClosed="modalClosed()"></details-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import QueueDetailsModal from './queueDetails.modal.vue';
    import CompareMixin from './../common/compare-mixin';
    import * as _ from 'lodash';

    export default {
        name: 'QueuesList',
        components: {
            'detailsModal': QueueDetailsModal
        },
        computed: {
            sortedByNameQueues(){
                return this.queues.sort(this.compareByName)
            }
        },
        data () {
            return {
                msg: 'Welcome to Your Vue.js App',
                socketClient: null,
                detailQueueName: null,
                queues: []
            }
        },
        mixins: [CompareMixin],
        mounted(){
            this.queues = this.$socketClient.getCachedQueues();
            this.$socketClient.events.on('queues_updated', this.onQueueUpdated.bind(this));
        },
        methods: {
            openDetails(queue){
                this.detailQueueName = queue;
            },
            modalClosed(){
                this.detailQueueName = null;
            },

            onQueueUpdated(data){
                this.queues = data['queues'];
            },

            removePendingJobs(queue){
                Vue.block();
                this.$jobsService.removePendingJobs(queue.name)
                    .then((result) => {
                        console.log("SUCCESS");
                        Vue.unblock();
                    });
            },
            getQueueStates(queue){
                return _.keys(queue.states).join(', ');
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .table{
        tbody{
            tr{
                &.wo-pending{
                    background: #d7fbcb;
                }
            }
        }
        thead{
            tr{
                th{
                    &.column{
                        &-rownumber{
                            width: 50px;
                        }
                        &-actions{
                            width: 50px;
                        }
                        &-status{
                            width: 150px;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/queues/queueList.component.vue